import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  DialogContentText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  SupplierOptions,
  LoadingBayOptions,
  BuildingOptions,
} from "../CONTANTS";
import { SET_EMPTY } from "config";
import { saveVehicleInspectionChecklistForm } from "services/wvForms";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  VEHICLE_SUPPLIER_CHECKLIST_FORM_SUCCESS,
} from "navigation/CONSTANTS";
import { useSelector } from "react-redux";
import { updateLang } from "i18n";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/system";
import WorkerDetailsFetcher from "../WorkerDetailsFetcher";
import { useFormFocusFlow } from "hooks/useFormFocusFlow";

const StyledMainCard = styled(Card)({
  border: `1px solid #dadce0`,
  wordWrap: "break-word",
  pageBreakInside: "avoid",
  background: "#fff",
  borderRadius: 6,
  borderTopWidth: 10,
  borderTopColor: "#1976d2",
  marginTop: 10,
});

const StyledCard = styled(Card)({
  minWidth: "80%",
});

const StyledTextField = styled(TextField)({
  minWidth: "50%",
})

const StyledSelect = styled(Select)({
  minWidth: "50%",
})

const INSPECTION_TYPE = "outbound";

const initialState = {
  building: "",
  hasPestEvidence: "",
  hasProductEvidence: "",
  isVehicleClean: "",
  hasWrongPallets: "",
  isTemperatureOk: "",
  hasInternalLights: "",
  hasOdours: "",
  vehicleRegistration: "",
  sealNumber: "",
  loadingBay: "",
  customer: "",
  palletsNumber: "",
  palletsPicked: "",
  palletsSupplied: "",
  isPalletsQualityOk: "",
  comments: "",
  casesPicked: "",
  selectedDate: dayjs(),
  startTime: dayjs().hour(9).minute(0),
  endTime: dayjs().hour(17).minute(30),
  workerEmail: "",
  workerName: "",
  workerCountry: "",
  workerId: ""
};

const OutboundSupplierVehicleForm = ({outboundSupplierOptions=[], buildingOptions=[]}) => {
  const { register, focusNext, clickNext } = useFormFocusFlow();
  const [processing, setProcessing] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [errorAlertDiag, setErrorAlertDiag] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialState);
  const { t, i18n } = useTranslation();
  const history = useHistory();
  // const outboundSupplierOptions = SupplierOptions(t);
  // const buildingOptions = BuildingOptions;
  const loadingBayOptions = LoadingBayOptions(t);

    useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnvironment = document.querySelector(".imtime-testEnvironment");
    if (header) {
      header.style.display = "none";
    }
    if (testEnvironment) {
      testEnvironment.style.display = "none";
    }
  }, []);

  useEffect(() => {
    if (
      formData.building.trim() === SET_EMPTY ||
      formData.loadingBay.trim() === SET_EMPTY ||
      formData.customer.trim() === SET_EMPTY ||
      formData.palletsNumber.trim() === SET_EMPTY ||
      formData.palletsSupplied.trim() === SET_EMPTY ||
      formData.hasPestEvidence.trim() === SET_EMPTY ||
      formData.hasProductEvidence.trim() === SET_EMPTY ||
      formData.isVehicleClean.trim() === SET_EMPTY ||
      formData.hasWrongPallets.trim() === SET_EMPTY ||
      formData.isTemperatureOk.trim() === SET_EMPTY ||
      formData.hasInternalLights.trim() === SET_EMPTY ||
      formData.hasOdours.trim() === SET_EMPTY ||
      !formData.selectedDate ||
      !formData.startTime ||
      !formData.endTime ||
      formData.workerId.trim() === SET_EMPTY ||
      formData.workerEmail.trim() === SET_EMPTY
    ) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [ formData ]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
   
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleProcessingOpen = () => {
    setProcessing(true);
  };
  const handleProcessingClose = () => {
    setProcessing(false);
  };

  const onSubmit = async () => {
    if (!isSubmitDisabled) {
      let form = {
        inspectionType: INSPECTION_TYPE,
        building: formData.building.trim(),
        selectedDate: formData.selectedDate.format("DD/MM/YYYY"),
        startTime: formData.startTime.format("hh:mm A"),
        endTime: formData.endTime.format("hh:mm A"),
        vehicleRegistration: formData.vehicleRegistration.trim(),
        sealNumber: formData.sealNumber.trim(),
        loadingBay: formData.loadingBay.trim(),
        customer: formData.customer.trim(),
        palletsNumber: formData.palletsNumber.trim(),
        palletsPicked: formData.palletsPicked.trim(),
        casesPicked: formData.casesPicked.trim(),
        palletsSupplied: formData.palletsSupplied.trim(),
        hasPestEvidence: formData.hasPestEvidence.trim(),
        hasProductEvidence: formData.hasProductEvidence.trim(),
        isVehicleClean: formData.isVehicleClean.trim(),
        hasWrongPallets: formData.hasWrongPallets.trim(),
        isPalletsQualityOk: formData.isPalletsQualityOk.trim(),
        isTemperatureOk: formData.isTemperatureOk.trim(),
        hasInternalLights: formData.hasInternalLights.trim(),
        hasOdours: formData.hasOdours.trim(),
        comments: formData.comments.trim(),
        workerEmail: formData.workerEmail.trim(),
        workerCountry: formData.workerCountry.trim(),
        workerName: formData.workerName.trim(),
        workerId: formData.workerId.trim(),
      };
      handleProcessingOpen();
      console.log("Outbound Form", form);
      try {
        let outboundVehicleSupplierFormID =
          await saveVehicleInspectionChecklistForm(form);
        console.log(
          `outboundVehicleChecklist-form outBoundFormID is ${outboundVehicleSupplierFormID}`
        );
        handleProcessingClose();
        history.push(VEHICLE_SUPPLIER_CHECKLIST_FORM_SUCCESS);
      } catch (error) {
        console.log(`outboundVehicleChecklist-Form error ${error}`);
      }
    } else {
      setErrorAlertDiag(true);
    }

    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value) {
        newErrors[key] = "This field is required";
      }
      if(errors.workerId){
          newErrors.workerId = errors.workerId;
        }
    });
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log("Submitted", formData);
    }
  };

  const { version } = useSelector((state) => state.translation.i18n);
  if (version && version > 1) {
    updateLang();
  }

  const onClear = () => {
    setFormData((prev) => ({
      ...initialState,
      email: prev.email,
    }));
  };

  return (
    <>
    <Grid
          container
          direction="column"
          alignItems="stretch"
          spacing={2}
          sx={{ paddingLeft: "10px" }}
        >
           <Grid item>
            <StyledMainCard>
              <CardContent>
                <Typography variant="h6" gutterBottom color="textPrimary">
                  {t("other.lblOutboundHeader")}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {t("other.lblOutboundFormLabel")}
                </Typography>
              </CardContent>
            </StyledMainCard>
          </Grid> 

           <WorkerDetailsFetcher 
            formData={formData} 
            setFormData={setFormData} 
            errors={errors}
            setErrors={setErrors}
          />

          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.building}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblBuildings")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="building"
                    value={formData.building}
                    onChange={handleChange}
                  >
                    {buildingOptions.length>0 ? buildingOptions.map((building) => (
                      <FormControlLabel
                        value={building.value}
                        control={<Radio />}
                        label={building.label}
                      />
                    )): "loading..."}
                  </RadioGroup>
                  <FormHelperText>{errors.building}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblSelectedDate")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid
                  container
                  direction="column"
                  alignItems="stretch"
                  spacing={1}
                >
                  <Grid item sx={{ width: 180 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <InputLabel sx={{ marginTop: 1, marginBottom: 1.5 }}>
                      {t("other.lblDate")}
                      </InputLabel>
                      <DatePicker
                        value={formData.selectedDate}
                        onChange={(newValue) =>
                          handleChange({target : {name:"selectedDate", value : newValue}})
                        }
                        format="DD-MM-YYYY"
                        maxDate={dayjs()}
                        slotProps={{
                          textField: {
                            name: "selectedDate",
                            required: true,
                            placeholder: "DD-MM-YYYY",
                            error: !!errors.selectedDate,
                            helperText: errors.selectedDate,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblStartTimeOutbound")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={{ marginTop: 1, marginBottom: 1.5 }}>
                  {t("other.lblTime")}
                  </InputLabel>
                  <Stack spacing={2} sx={{ width: 170 }}>
                    <TimePicker
                      slotProps={{
                        textField: {
                          name: "startTime",
                          required: true,
                          error: !!errors.startTime,
                          helperText: errors.startTime,
                        },
                      }}
                      value={formData.startTime}
                      onChange={(newValue) =>
                        handleChange({target : {name:"startTime", value : newValue}})
                      }
                    />
                  </Stack>
                </LocalizationProvider>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblEndTimeOutbound")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={{ marginTop: 1, marginBottom: 1.5 }}>
                  {t("other.lblTime")}
                  </InputLabel>
                  <Stack spacing={2} sx={{ width: 170 }}>
                    <TimePicker
                      slotProps={{
                        textField: {
                          name: "endTime",
                          required: true,
                          error: !!errors.endTime,
                          helperText: errors.endTime,
                        },
                      }}
                      value={formData.endTime}
                      onChange={(newValue) =>
                        handleChange({target : {name:"endTime", value : newValue}})
                      }
                    />
                  </Stack>
                </LocalizationProvider>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {" "}
                  {t("other.lblVehicleRegistration")}
                </Typography>
                <StyledTextField
                  name="vehicleRegistration"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.vehicleRegistration}
                  onChange={handleChange}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {" "}
                  {t("other.lblSealNumber")}
                </Typography>
                <StyledTextField
                  name="sealNumber"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.sealNumber}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === "Next" || e.keyCode === 13) {
                      e.preventDefault();
                      clickNext(0);
                    }
                  }}
                  inputRef={register(0)}
                  inputProps={{ 
                    enterKeyHint: "next",
                  }}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblLoadingBay")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid item>
                  <FormControl variant="outlined">
                    <InputLabel id="loadingbay-label">
                      {t("other.lblChoose")}
                    </InputLabel>
                    <StyledSelect
                      name="loadingBay"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      value={formData.loadingBay}
                      onChange={handleChange}
                      error={!!errors.loadingBay}
                      helperText={errors.loadingBay}
                      ref={register(1)}
                    >
                      {loadingBayOptions.map((duration) => (
                        <MenuItem value={duration.value}>
                          {duration.label}
                        </MenuItem>
                      ))}
                    </StyledSelect>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errors.loadingBay}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblClient")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid item>
                  <FormControl variant="outlined">
                    <InputLabel id="support/customer-label">
                      {t("other.lblChoose")}
                    </InputLabel>
                    <StyledSelect
                      labelId="supplier/customer-label"
                      id="supplier/customer"
                      name="customer"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      value={formData.customer}
                      onChange={handleChange}
                      error={!!errors.customer}
                      helperText={errors.customer}
                    >
                      {outboundSupplierOptions.map((supplier) => (
                        <MenuItem value={supplier.value}>
                          {supplier.label}
                        </MenuItem>
                      ))}
                    </StyledSelect>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errors.customer}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblPalletsLoaded")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <StyledTextField
                  name="palletsNumber"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.palletsNumber}
                  onChange={handleChange}
                  error={!!errors.palletsNumber}
                  helperText={errors.palletsNumber}
                   type="number"
                  inputProps={{ 
                    min: 0,
                    step: 1 
                  }}
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === '.' || e.key === 'e') {
                      e.preventDefault();
                    }
                  }}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblPalletsPicked")}
                </Typography>
                <StyledTextField
                  id="palletsPicked"
                  name="palletsPicked"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.palletsPicked}
                  onChange={handleChange}
                  type="number"
                  inputProps={{ 
                    min: 0,
                    step: 1 
                  }}
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === '.' || e.key === 'e') {
                      e.preventDefault();
                    }
                  }}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblCasesPicked")}
                </Typography>
                <StyledTextField
                  name="casesPicked"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.casesPicked}
                  onChange={handleChange}
                  type="number"
                  inputProps={{ 
                    min: 0,
                    step: 1 
                  }}
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === '.' || e.key === 'e') {
                      e.preventDefault();
                    }
                  }}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblPalletsSupplied")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <StyledTextField
                  id="palletsSupplied"
                  name="palletsSupplied"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.palletsSupplied}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    handleChange({ target: { name: "palletsSupplied", value } });
                  }}
                  error={!!errors.palletsSupplied}
                  helperText={errors.palletsSupplied}
                  type="text"
                  inputProps={{ 
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    enterKeyHint: "next",
                    min: 0,
                    step: 1 
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
                    ) {
                      e.preventDefault();
                    }

                    if (e.key === "Enter" || e.key === "Next" || e.keyCode === 13) {
                      e.preventDefault();
                      focusNext(2);
                    }
                  }}
                  inputRef={register(2)}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasPestEvidence}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblPestEvidence")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="hasPestEvidence"
                    value={formData.hasPestEvidence}
                    onChange={handleChange}
                    error={!!errors.hasPestEvidence}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio inputRef={register(3)} />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasPestEvidence}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasProductEvidence}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblProductDamageOutbound")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="hasProductEvidence"
                    value={formData.hasProductEvidence}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasProductEvidence}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.isVehicleClean}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblVehicleCleanliness")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="isVehicleClean"
                    value={formData.isVehicleClean}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.isVehicleClean}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasWrongPallets}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblWrongPallets")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="hasWrongPallets"
                    value={formData.hasWrongPallets}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasWrongPallets}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblPalletsQualityOutbound")}
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="isPalletsQualityOk"
                    value={formData.isPalletsQualityOk}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.isTemperatureOk}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblTemperature")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="isTemperatureOk"
                    value={formData.isTemperatureOk}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.isTemperatureOk}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasInternalLights}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblInternalLights")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="hasInternalLights"
                    value={formData.hasInternalLights}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasInternalLights}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>

          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasOdours}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblOdour")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="hasOdours"
                    value={formData.hasOdours}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasOdours}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent sx={{ paddingBottom: 0 }}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblCommentsInfo")}
                </Typography>
                <StyledTextField
                  id="comments"
                  label={t("other.lblYourAnswer")}
                  name="comments"
                  variant="standard"
                  fullWidth={true}
                  value={formData.comments}
                  onChange={handleChange}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              spacing={2}
            >
              <Grid item>
                <Button
                  type="Button"
                  variant="text"
                  sx={{ color: "#808080" }}
                  onClick={onClear}
                >
                  {t("other.lblClearForm")}
                </Button>
              </Grid>
              <Grid item sx={{ marginBottom: 0 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onSubmit}
                  // disabled={isSubmitDisabled}
                >
                  {t("pgHome.btEmpId")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      <Dialog
        open={processing}
        onClose={handleProcessingClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("other.lblSubmitting")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("other.lblPleaseWaitToSubmt")} <br /> <br />
            <Grid container justifyContent="center">
              <Grid item>
                <CircularProgress />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={errorAlertDiag}
        onClose={() => {
          setErrorAlertDiag(false);
        }}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
      >
        <DialogTitle id="error-dialog-title"> {t("other.tlError")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">
            {t("other.lblPleaseFillAllFields")} <br /> <br />
            <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setErrorAlertDiag(false);
                  }}
                >
                  {t("pgPunch.btnOK")}
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OutboundSupplierVehicleForm;
